import React from "react";

export const NextIconDisabled = () => {
  return (
    <svg
      width="39"
      height="38"
      viewBox="0 0 39 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="19.1738"
        cy="19"
        r="18.2875"
        transform="rotate(-180 19.1738 19)"
        stroke="#A7A6A6"
        stroke-width="1.425"
      />
      <path
        d="M17.7701 11.7871L15.7227 13.8345L22.3732 20.4996L15.7227 27.1647L17.7701 29.2121L26.4826 20.4996L17.7701 11.7871Z"
        fill="#A7A6A6"
      />
    </svg>
  );
};

export const NextIconEnabled = () => {
  return (
    <svg
      width="42"
      height="41"
      viewBox="0 0 42 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="20.6738"
        cy="20.5"
        r="19.7313"
        stroke="#355ADD"
        stroke-width="1.5375"
      />
      <path
        d="M17.7701 11.7871L15.7227 13.8345L22.3732 20.4996L15.7227 27.1647L17.7701 29.2121L26.4826 20.4996L17.7701 11.7871Z"
        fill="#355ADD"
      />
    </svg>
  );
};

export const PrevIconDisabled = () => {
  return (
    <svg
      width="39"
      height="38"
      viewBox="0 0 39 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="19.1738"
        cy="19"
        r="18.2875"
        transform="rotate(-180 19.1738 19)"
        stroke="#A7A6A6"
        stroke-width="1.425"
      />
      <path
        d="M21.8656 27.0762L23.7632 25.1785L17.5993 19.0012L23.7632 12.8238L21.8656 10.9262L13.7906 19.0012L21.8656 27.0762Z"
        fill="#A7A6A6"
      />
    </svg>
  );
};

export const PrevIconEnabled = () => {
  return (
    <svg
      width="42"
      height="41"
      viewBox="0 0 42 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="20.6738"
        cy="20.5"
        r="19.7313"
        stroke="#355ADD"
        stroke-width="1.5375"
      />
      <path
        d="M21.8656 27.0762L23.7632 25.1785L17.5993 19.0012L23.7632 12.8238L21.8656 10.9262L13.7906 19.0012L21.8656 27.0762Z"
        fill="#355ADD"
      />
    </svg>
  );
};

export const LockIcon = () => {
  return (
    <svg

      viewBox="0 0 32 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15.9039" cy="15.4811" r="15.4615" fill="#18181B" />
      <path
        d="M15.9034 4.14258C13.2505 4.14258 11.0931 6.3385 11.0931 9.03873V11.4868H8.68799V23.7272H23.1188V11.4868H20.7136V9.03873C20.7136 6.3385 18.5562 4.14258 15.9034 4.14258ZM15.9034 6.59066C17.2298 6.59066 18.3085 7.68862 18.3085 9.03873V11.4868H13.4982V9.03873C13.4982 7.68862 14.5769 6.59066 15.9034 6.59066ZM14.7008 15.1589H17.1059V20.0551H14.7008V15.1589Z"
        fill="white"
      />
    </svg>
  );
};

export const WhiteLockIcon = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="36" height="36" rx="18" fill="black" fill-opacity="0.5"/>
    <path d="M12 28.2314C11.45 28.2314 10.9792 28.0356 10.5875 27.6439C10.1958 27.2523 10 26.7814 10 26.2314V16.2314C10 15.6814 10.1958 15.2106 10.5875 14.8189C10.9792 14.4273 11.45 14.2314 12 14.2314H13V12.2314C13 10.8481 13.4875 9.66895 14.4625 8.69395C15.4375 7.71895 16.6167 7.23145 18 7.23145C19.3833 7.23145 20.5625 7.71895 21.5375 8.69395C22.5125 9.66895 23 10.8481 23 12.2314V14.2314H24C24.55 14.2314 25.0208 14.4273 25.4125 14.8189C25.8042 15.2106 26 15.6814 26 16.2314V26.2314C26 26.7814 25.8042 27.2523 25.4125 27.6439C25.0208 28.0356 24.55 28.2314 24 28.2314H12ZM12 26.2314H24V16.2314H12V26.2314ZM18 23.2314C18.55 23.2314 19.0208 23.0356 19.4125 22.6439C19.8042 22.2523 20 21.7814 20 21.2314C20 20.6814 19.8042 20.2106 19.4125 19.8189C19.0208 19.4273 18.55 19.2314 18 19.2314C17.45 19.2314 16.9792 19.4273 16.5875 19.8189C16.1958 20.2106 16 20.6814 16 21.2314C16 21.7814 16.1958 22.2523 16.5875 22.6439C16.9792 23.0356 17.45 23.2314 18 23.2314ZM15 14.2314H21V12.2314C21 11.3981 20.7083 10.6898 20.125 10.1064C19.5417 9.52311 18.8333 9.23145 18 9.23145C17.1667 9.23145 16.4583 9.52311 15.875 10.1064C15.2917 10.6898 15 11.3981 15 12.2314V14.2314Z" fill="#ECE9E4"/>
    </svg>
  );
};

export const PlayIcon = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="36" height="36" rx="18" fill="black" fill-opacity="0.5"/>
    <path d="M13.5 12.0236C13.5 11.4264 14.1301 11.0551 14.6302 11.3576L25.1298 17.7091C25.6234 18.0076 25.6234 18.7424 25.1298 19.0409L14.6302 25.3924C14.1301 25.6949 13.5 25.3236 13.5 24.7264L13.5 12.0236Z" fill="white"/>
    </svg>
  );
};

export const PaddockIcon = ({ width = 21, height = 21 ,color = "white"}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_7853_27263)">
        <path
          d="M8.18999 5.45998V7.34998H10.815V5.45998C10.815 2.41501 8.40001 0 5.45998 0C2.41501 0 0 2.41501 0 5.45998V9.44999H2.62498V5.45998C2.62498 3.98996 3.88498 2.72997 5.355 2.72997C6.93 2.62498 8.18999 3.88498 8.18999 5.45998Z"
          fill={color}
        />
        <path
          d="M19.5298 9.24023H7.76982C6.9298 9.24023 6.2998 9.87023 6.2998 10.7102V19.5302C6.2998 20.3703 6.9298 21.0003 7.76982 21.0003H19.5298C20.3698 21.0003 20.9998 20.3703 20.9998 19.5302V10.7102C20.9998 9.97527 20.2648 9.24023 19.5298 9.24023ZM14.9098 17.7452H12.4948L13.0198 15.2252C12.5998 15.0153 12.2848 14.4902 12.2848 13.9652C12.2848 13.1252 12.9148 12.4952 13.7548 12.4952C14.5948 12.4952 15.2248 13.1252 15.2248 13.9652C15.2248 14.4902 14.9098 14.9102 14.4898 15.2252L14.9098 17.7452Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_7853_27263">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};


export const Xclose = ({ width = 13, height = 13 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 ${width} ${height}" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.24333 12.9979C0.921761 13.0167 0.605514 12.9092 0.361271 12.6982C-0.120424 12.2112 -0.120424 11.4247 0.361271 10.9377L10.9088 0.336928C11.4098 -0.134243 12.196 -0.108051 12.6648 0.39548C13.0887 0.85082 13.1134 1.55069 12.7226 2.03506L2.11295 12.6982C1.87185 12.9062 1.56068 13.0134 1.24333 12.9979Z" fill="#FD3300" />
      <path d="M11.668 12.9933C11.3435 12.9919 11.0324 12.8622 10.8019 12.632L0.297507 2.05598C-0.146932 1.53344 -0.0865085 0.747052 0.432493 0.299543C0.895715 -0.0998476 1.57888 -0.0998476 2.04206 0.299543L12.6083 10.8756C13.1072 11.3457 13.133 12.1341 12.6659 12.6363C12.6474 12.6563 12.6282 12.6756 12.6083 12.6943C12.3496 12.9208 12.0091 13.0291 11.668 12.9933Z" fill="#FD3300" />
    </svg>
  );
};